/*
 * @Autor: dingxiaolin
 * @Date: 2020-03-27 21:47:21
 * @LastEditors: qiuwenjing qiuwenjing@vip56.cn
 * @LastEditTime: 2023-05-10 11:16:14
 */
import Vue from 'vue';
import '@/style/index.scss'; // global css
import 'amfe-flexible';
import App from './App.vue';
import router from './router';
import ElementUI from 'element-ui';
import store from './vuex';
import { has,hasShow } from './common/util/btnPermissions'
import vueSwiper from 'vue-awesome-swiper';
import VueClipboard from 'vue-clipboard2';
import preview from 'vue-photo-preview';
import dayjs from 'dayjs';
import Bus from './common/util/bus';
import draggable from 'vuedraggable';
import axios from "axios";
import mixin from '@/common/util/minxi';
import 'viewerjs/dist/viewer.css';
import Viewer from 'v-viewer';
import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Viewer);
Vue.use(Vant);

// import key from '../static/key';
// window.$key = key;
Vue.prototype.window = window;
Vue.component('draggable', draggable);
Vue.use(vueSwiper)
    .use(VueClipboard)
    .use(preview)
    .use(ElementUI, {
        size: 'small'
    });
Vue.config.productionTip = false;
Vue.prototype.TITLE = process.env.TITLE;
Vue.prototype.$store = store;
Vue.prototype.$axios = axios;
Vue.prototype.$bus = Bus;
Vue.prototype.$dayjs = dayjs;
Vue.mixin({
    methods:mixin
})
// import { waves } from '@/directive/waves';
// Vue.directive('waves', waves);
// import actionPermission from '@/directive/actionPermission';
// Vue.directive('permission', actionPermission);
Vue.directive('has', has);
Vue.directive('hasShow', hasShow);
import directive from '@/directive';
Vue.use(directive);
export default new Vue({
    el: '#app',
    router,
    store,
    render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.ts